import { fitIn } from "@/utils/imageHandler";
import Image from "next/legacy/image";
import Link from "next/link";
import ContentWishlistComponent from "../parts/ContentWishlistComponent";

const OpinionCard = ({ data, cardHeight }) => {
  return (
    <div className='relative'>
      <div className='absolute z-20 top-1 right-1'>
        <ContentWishlistComponent
          item={data}
          content_type_name_prop={data.content_type.name}
          isDarkBackground={false}
        />
      </div>
      <Link
        href={`/opinions/${data.slug}`}
        className='relative flex overflow-hidden transition-transform duration-300 origin-center rounded-md bg-gradient-to-br from-white/5 to-white/20'
      >
        <div
          className={`block relative aspect-[188/250] rounded-md overflow-hidden w-full ${
            cardHeight ?? "h-full"
          }`}
        >
          <Image
            src={fitIn(data.thumbnail_url, 800)}
            alt=''
            layout='fill'
            objectFit='cover'
          />
          <span className='absolute inset-0 bg-gradient-to-b from-transparent to-[#23212E]'></span>
          <div className='absolute bottom-0 w-full h-full px-3 pt-2 pb-4 text-center text-white md:pt-3 md:px-4 md:pb-5'>
            <div className='flex flex-col items-center justify-between h-full'>
              <span className='inline-block mb-1 text-xs font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-1 to-red-1'>
                {data.content_type.name}
              </span>
              <div>
                <p className='text-base 2xl:text-2xl font-semibold leading-[0.9] tracking-tight text-transparent font-display bg-clip-text bg-gradient-to-r from-yellow-1 to-red-1'>
                  {data.authors?.[0]?.name}
                </p>
                <p className='mt-1 text-[10px] lg:text-xs font-medium leading-snug lg:leading-tight'>
                  {data.authors?.[0]?.job_title}
                </p>
                <p className='mt-0.5 lg:mt-1 text-[9px] md:text-[11px] font-light leading-snug lg:leading-tight'>
                  {data.authors?.[0]?.company_name}
                </p>
                <p className='mt-3 text-[10px] leading-snug lg:mt-5 lg:text-sm line-clamp-2'>
                  {data.title}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default OpinionCard;
